var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-timesheet" },
    [
      _c("timesheet-fieldset", {
        attrs: { layout: _vm.layoutData },
        on: { change: _vm.onChange }
      }),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-top-color": "#ddd", margin: "8px 0" }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", id: "leftover-duration" },
        domProps: { value: _vm.hoursDay - _vm.hoursTotal }
      }),
      _vm._v(" "),
      !_vm.isModal
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between"
              }
            },
            [
              _c("div", [
                _c("span", [
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Heures:")
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: {
                        color:
                          _vm.hoursTotal == _vm.hoursDay || !_vm.hasHoursDay
                            ? "#1e9765"
                            : "#f00"
                      }
                    },
                    [_vm._v(_vm._s(_vm.hoursTotal))]
                  )
                ]),
                _vm._v("  \n      "),
                _vm.hasHoursDay
                  ? _c("span", [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("Journée:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          style: {
                            color:
                              _vm.hoursTotal == _vm.hoursDay
                                ? "#1e9765"
                                : "#f00"
                          }
                        },
                        [_vm._v(_vm._s(_vm.hoursDay))]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn blue",
                    on: { click: _vm.sendTimesheetValidation }
                  },
                  [_vm._v("Envoyer")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn purple",
                    on: { click: _vm.saveTimesheet }
                  },
                  [_vm._v("Enregistrer")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn default",
                    attrs: { href: _vm.cancelUrl }
                  },
                  [_vm._v("Annuler")]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }